<section style="margin-top: 120px;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                            <li><span class="mediumFontSize"><strong>How do I sign up?</strong></span></li>
                            <p class="theme_color fontSize">
                                Shoot us a quick email at <a href="mailto:customerservice@sficompliance.com">customerservice@sficompliance.com</a> or call at <strong>303-649-1304</strong> to
                                request a new
                                user login. To set up your account we will need to know the following: first and last
                                name, the company
                                you work for, what site you want to view, and the email you want the reports sent to.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="150">
                            <li><span class="mediumFontSize"><strong>I am having trouble logging in, what do I
                                        do?</strong></span></li>
                            <p class="theme_color fontSize">
                                When on the client login page, you can select forgot password and reset your password
                                using your email.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="200">
                            <li><span class="mediumFontSize"><strong>I have reset my password and still can
                                        login.</strong></span></li>
                            <p class="theme_color fontSize">
                                If you are still having issues contact us at <strong>303-649-1304</strong> or
                                <a href="mailto:customerservice@sficompliance.com">customerservice@sficompliance.com</a> and we
                                can set a temporary password for you.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><span class="mediumFontSize"><strong>I received an email that I have a new report,
                                        how do I view this on the DMS?</strong></span></li>
                            <p class="theme_color fontSize">
                                In order to view new reports, you will need to go to dms.sficompliance.com and login.
                                Once you are
                                logged in, on the left-hand side select “Inspections” then “Jobsite Inspections” and you
                                will see all the
                                reports pull up for your site. From here you can sort by report number, date, site and
                                inspector. If you
                                show no reports on this screen please contact us so we can resolve the issue for you.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="300">
                            <li><span class="mediumFontSize"><strong>I am not receiving the new report
                                        emails.</strong></span></li>
                            <p class="theme_color fontSize">
                                If you are not receiving emails from us, please confirm that we are an approved sender
                                in your mailing
                                system. You should allow emails from notifications@sficompliance.com in order to get
                                password reset
                                emails, new report notifications and to adjust site contact lists.
                            </p>
                        </ul>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="350">
                            <li><span class="mediumFontSize"><strong>Where do I go to download the app?
                                    </strong></span></li>
                            <p class="theme_color fontSize">
                                Our mobile DMS app is available on the Google Play Store and the Apple App store under
                                “SFI DMS Safety App”
                            </p>

                            <div class="row" style="padding-top: 10px;padding-bottom: 10px;" data-aos="fade-up" data-aos-delay="200">
                                <div class="col-lg-3 col-3 text-center">
                                    <a href="https://play.google.com/store/apps/details?id=com.sfi.mobileapp" target="_blank"><i class="fa fa-android" style="font-size: 64px;color: gray;"></i></a>
                                </div>
                                <div class="col-lg-3 col-3 text-center">
                                    <a href="https://apps.apple.com/app/sfi-dms-safety-app/id1466584086" target="_blank"><i class="fa fa-apple" style="font-size: 64px;color: gray;"></i></a>
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>